import React from "react"
import { useStyles } from "./card-historico-pedido-produto-styles"
import { Card, Grid, Typography } from "@material-ui/core"
import { ProdsModel } from "models/api/venda/venda-completa-model"
import { toDecimalString } from "utils/to-decimal"

export type CardHistoricoPedidoProdutoProps = {
    model: ProdsModel
}

export const CardHistoricoPedidoProduto = ({ model }: CardHistoricoPedidoProdutoProps) => {
    const classes = useStyles()

    return (
        <Card className={classes.card} variant="outlined">
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="body1" className={classes.prod}>
                        {model.xProd}
                    </Typography>
                </Grid>
                <Grid item xs>
                    <Typography variant="body2">
                        {model.qCom} {model.uTrib}
                    </Typography>
                </Grid>
                <Grid item xs="auto">
                    <Typography variant="body1">
                        R$ {toDecimalString(model.vProd)}
                    </Typography>
                </Grid>
            </Grid>
        </Card>
    )
}